import {
  AppBarDropdownMenu,
  AppBarMenuItem,
  NavbarWithOverflow,
  useMobileMenu,
} from "@gearbox-protocol/ui-kit";
import { useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { id: "proposals", path: "/", label: "Proposals" },
  { id: "history", path: "/history", label: "History" },
  { id: "recovery", path: "/recovery", label: "Recovery" },
] as const;

function getActivePath(pathname: string) {
  if (pathname.startsWith("/history")) return "/history";
  if (pathname.startsWith("/recovery")) return "/recovery";
  return "/proposals";
}

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const activePath = getActivePath(location.pathname);

  const items = NAV_ITEMS.map(({ id, path, label }) => ({
    id,
    label,
    active: path === "/" ? activePath === "/proposals" : activePath === path,
    onClick: () => navigate(path),
  }));

  return <NavbarWithOverflow items={items} moreLabel="More" />;
}

export function NavigationMobile() {
  const navigate = useNavigate();
  const { closeMobileMenu } = useMobileMenu();

  const handleNavigate = (path: string) => {
    navigate(path);
    closeMobileMenu();
  };

  return (
    <AppBarDropdownMenu className="mt-0 min-w-0 w-full shadow-none bg-transparent p-0">
      <AppBarMenuItem onClick={() => handleNavigate("/")}>
        Proposals
      </AppBarMenuItem>
      <AppBarMenuItem onClick={() => handleNavigate("/history")}>
        History
      </AppBarMenuItem>
      <AppBarMenuItem onClick={() => handleNavigate("/recovery")}>
        Recovery
      </AppBarMenuItem>
    </AppBarDropdownMenu>
  );
}
